/**
 * Hook to navigate to a new session with consistent cleanup.
 * Clears session, transcript, and recording state before navigating.
 * Used by Header, SessionHeader, and SessionsList.
 */

import { useNavigate } from 'react-router-dom';
import { useAppDispatch } from '../store/store';
import { clearCurrentSession } from '../store/sessionSlice';
import { resetTranscript } from '../store/transcriptSlice';
import { resetRecording } from '../store/recordingSlice';
import { useHardReloadIfPolling } from './useHardReloadIfPolling';

export const useNewSession = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const hardReloadIfPolling = useHardReloadIfPolling();

  const startNewSession = () => {
    if (hardReloadIfPolling('/session/new')) return;
    dispatch(clearCurrentSession());
    dispatch(resetTranscript());
    dispatch(resetRecording());
    navigate('/session/new');
  };

  return startNewSession;
};
